module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan épaule.768ae516.svg";